import { Injectable, computed, inject, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { globalConfig } from '../utils/globalConfig';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class GuardService {
  private http = inject(HttpClient);

  #stateUsuarioData = signal<any>({
    nombreCompleto: String,
    usuario: {},
    cuenta: {},
    tipoPago: {},
  });

  public usuarioData = computed(() => this.#stateUsuarioData());

  constructor() {}

  authenticated(): Observable<object> {
    return this.http.get('/auth/validate-token');
  }

  setToken(token: string) {
    sessionStorage.setItem(globalConfig.tokenApi, token);
  }
  /**
   * "skip-Interceptor" sive de bandera para saltar el interceptor http-interceptor.interceptor
   * la variable "mensaje" se muestra en el mensaje de error del unauthorized.interceptor
   * @param token
   * @returns
   */
  validateToken(token: string): Observable<object> {
    const mensaje = 'Ruta no valida, intente nuevamente.';
    return this.http.get('/auth/validate-token', {
      headers: new HttpHeaders({
        'skip-Interceptor': mensaje,
        Authorization: `Bearer ${token}`,
      }),
    });
  }

  getTemporalToken(key: string) {
    return this.http.get(`/usuario-front/validate-token/${key}`);
  }

  setUserData(cuenta: any, usuario: any) {
    this.#stateUsuarioData.set({
      nombreCompleto: `${usuario.nombres} ${usuario.apellidos}`,
      usuario,
      cuenta,
      primerInicio: usuario.primerInicio,
      fechaNacimiento: usuario.fechaNacimiento,
      tipoPago: cuenta.tipoPago,
    });
  }

  updateUsuarioData(usuario: any) {
    this.#stateUsuarioData.update((current) => {
      return {
        ...current,
        nombreCompleto: `${usuario.nombres} ${usuario.apellidos}`,
        usuario: {
          ...current.usuario,
          ...usuario,
        },
      };
    });
  }

  updateCuentaData(cuenta: any) {
    this.#stateUsuarioData.update((current) => ({
      ...current,
      cuenta,
    }));
  }
}
